import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { INotes, IUser } from '../interfaces';
import axios, { AxiosRequestConfig, AxiosPromise, AxiosResponse } from 'axios';

const baseUrl = process.env.REACT_APP_API_BASE_URL || '/api';

interface GQLResponse<T> {
  data: T;
}

export const gql = async <T>({ query, returnFunc }: { query: string, returnFunc: string }): Promise<any> => {
  const response: AxiosResponse<GQLResponse<T>> = await axios({
    url: baseUrl,
    method: "POST",
    data: {
      query: query
    }
  });
  return response.data.data[returnFunc as keyof T] as any;
};


export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getUser: builder.query<IUser[], void>({
      query: () => '/user',
    }),
    mockAuthenticate: builder.mutation<{ token: string }, { username: string; password: string }>({
      query: (credentials) => ({
        url: '/mock-auth',
        method: 'POST',
        body: credentials,
      }),
    }),
    register: builder.mutation<{ token: string }, {
      first_name: string;
      last_name: string;
      status: number;
      organization_id: number;
      role: number;
      level: number;
      job_title?: string;
      email: string;
      phone?: string;
      country?: string;
      address_street_city?: string;
      postal_code?: string;
      photo?: number;
      notes?: INotes[]
    }>({
      query: (credentials) => ({
        url: '/register',
        method: 'POST',
        body: credentials,
      }),
    }),
    
    signOut: builder.mutation<{ message: string }, void>({
      query: () => ({
        url: '/sign-out',
        method: 'POST',
      }),
    }),

    googleLogin: builder.mutation<{ token: string }, { tokenId: string }>({
      query: ({ tokenId }) => ({
        url: '/auth/google',
        method: 'POST',
        body: { tokenId },
      }),
    }),

    githubLogin: builder.mutation<{ token: string }, { tokenId: string }>({
      query: ({ tokenId }) => ({
        url: '/auth/github',
        method: 'POST',
        body: { tokenId },
      }),
    }),
  }),
});

export const {
  useGetUserQuery,
  useMockAuthenticateMutation,
  useRegisterMutation,
  useSignOutMutation,
  useGoogleLoginMutation,
  useGithubLoginMutation,
} = api;
